export enum PrescriptionLineStatus {
    Draft = 1,
    Prescribed,
    Archived
}
